<div class="container">
    <div class="row">
        <div class="col-md-12">

            <div class="d-flex justify-content-center small-margin-top" *ngIf="isLoading.loadingSavedSearches">
                <zint-loader></zint-loader>
            </div>

            <div id="saved-searches-tab" *ngIf="!isLoading.loadingSavedSearches" [ngClass]="{'updating-saved-search': isLoading.loadingSavedSearchesAddRemoveUserOrTeam}">

                <h2 class="small-margin-top">Saved Searches:</h2>

                <h5 class="medium-margin-top" *ngIf="sharedSavedSearches">Shared Searches:</h5>
                <p class="small-margin-top text-center" *ngIf="!sharedSavedSearches || sharedSavedSearches.length == 0">There are no shared searches associated with your account.</p>
                <table *ngIf="sharedSavedSearches && sharedSavedSearches.length > 0" class="table table-striped table-bordered small-margin-top" style="table-layout:fixed;">
                    <thead>
                        <tr>
                            <td>Search Name</td>
                            <td style="width: 40%">Parameters</td>
                            <td>Re-run Search</td>
                            <td *ngIf="isSuperUser" colspan="2">Users and Teams Shared With</td>                            
                            <td *ngIf="isSuperUser">Delete</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let search of sharedSavedSearches">
                            <td class="text-break">{{ search.name }}</td>
                            <td>
                                <div class="overflow-auto"> <search-parameters [inputParams]="{'searchTags': search.outputForParamsDisplay, 'enableClearing': false}"></search-parameters> </div>
                            </td>
                            <td>
                                <a class="rounded-btn-base rounded-btn-dark-hover" [attr.href]="pubMethods.encodeSavedSearchURL(search)" target="_blank"><i class="fal fa-play"></i></a>
                            </td>
                            <td colspan="2" *ngIf="search.can_edit && isSuperUser">                                
                                <zint-permissions
                                    [allUsers]="organisationUsers"
                                    [allTeams]="organisations"
                                    [existingTeams]="search.shared_teams"
                                    [existingUsers]="search.shared_users"
                                    (onPermissionChange)="handlePermissionsChange($event, search.id)"
                                ></zint-permissions>
                            </td>
                            <td *ngIf="isSuperUser">
                                <button *ngIf="search.can_edit" class="rounded-btn-base rounded-btn-dark-hover" (click)="deleteSavedSearch(search.id)"><i class="fal fa-trash"></i></button>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <h5 class="medium-margin-top">Your Searches:</h5>
                <p class="small-margin-top text-center" *ngIf="!privateSavedSearches || privateSavedSearches.length == 0">You have not yet saved any searches.</p>
                <table *ngIf="privateSavedSearches && privateSavedSearches.length > 0" class="table table-striped table-bordered small-margin-top" style="table-layout:fixed;">
                    <thead>
                        <tr>
                            <td>Search Name</td>
                            <td style="width: 50%">Parameters</td>
                            <td>Re-run Search</td>
                            <td>Delete</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let search of privateSavedSearches">
                            
                            <td>{{ search.name }}</td>
                            <td>
                                <div class="overflow-auto"><search-parameters [inputParams]="{'searchTags': search.outputForParamsDisplay, 'enableClearing': false}"></search-parameters> </div>    </td>
                            <td><a class="rounded-btn-base rounded-btn-dark-hover" [attr.href]="pubMethods.encodeSavedSearchURL(search)" target="_blank"><i class="fal fa-play"></i></a></td>
                            <td><button class="rounded-btn-base rounded-btn-dark-hover" (click)="deleteSavedSearch(search.id)"><i class="fal fa-trash"></i></button></td>
                        </tr>
                    </tbody>
                </table>

            </div>


        </div>
    </div>
</div>
